  import React from "react";
  import PropTypes from "prop-types";
  import { Router, Switch, Route, Redirect } from "react-router-dom";
  import history from "./History";
  import { AUTH_CONTEXT_TYPE } from "../utils/authPortal";
  import { getDefaultAppEntryPath } from "../utils/defaultPortalHost";
  import { ADMIN_PREFIX, COMPANY_PREFIX, ROUTE_PATHS } from "../utils/RoutesPaths";
  import PublicRoute from "./PublicRoute";
  import PrivateRoute from "./PrivateRoute";
  import { withAuthType } from "./authWrappers";
  // ========= Components =========
  import Login from "../containers/Auth/Login";
  import CompanyLoginFlow from "../containers/Auth/CompanyLoginFlow";
  import RegistrationFlow from "../containers/Auth/Registration/RegistrationFlow";
  import CompanyPendingApprovalPage from "../containers/Auth/CompanyPendingApprovalPage";
  import CompanyDeactivated from "../containers/Auth/CompanyDeactivated";
  import ChangePassword from "../containers/Auth/ChangePassword";
  import ForgetPassword from "../containers/Auth/ForgetPassword";
  import ResetPasswordSuccess from "../containers/Auth/ResetPasswordSuccess";
  import EventsListView from "../containers/Admin-portal/Events/EventsListView";
  import CreateEventV2 from "../containers/Admin-portal/Events/CreateEventV2";
  import ViewEventV2 from "../containers/Admin-portal/Events/ViewEventV2";
  import InviteApplicants from "../containers/Admin-portal/Events/ViewEventV2/ApplicantsTab/InviteApplicants";
  import Employees from "../containers/Admin-portal/Employees";
  import Requests from "../containers/Admin-portal/Requests";
  import PromotionRequests from "../containers/Admin-portal/PromotionRequests";
  import DemoRequests from "../containers/Admin-portal/DemoRequests";
  import RegistrationReqPage from "../containers/Admin-portal/companies/RegistrationReq/RegistrationReqPage";
  import CompanyViewDetailsPage from "../containers/Admin-portal/companies/RegistrationReq/CompanyViewDetailsPage";
  import CompaniesList from "../containers/Admin-portal/companies/CompaniesList";
  import CompanyDetailsPage, {
    CompanyDetailsClientsTabRedirect,
  } from "../containers/Admin-portal/companies/CompaniesList/CompanyDetailsPage";
  import CompanyEditPage from "../containers/Admin-portal/companies/CompaniesList/CompanyEditPage";
  import ReviewProfileUpdateRequestPage from "../containers/Admin-portal/companies/CompaniesList/CompanyDetailsPage/ReviewProfileUpdateRequestPage";
  import ProfileEditRequestsPage from "../containers/Admin-portal/companies/ProfileEditRequests/ProfileEditRequestsPage";
  import PublishingRequests from "../containers/Admin-portal/PublishingRequests";
  import ResetPasswordInternally from "../containers/Auth/ResetPasswordInternally";
  import ResetPasswordFlow from "../containers/Auth/resetPassword/ResetPasswordFlow";
  import AddProjectManager from "../containers/Admin-portal/Employees/AddProjectManager";
  import Applicants from "../containers/Admin-portal/Applicants";
  import ViewApplicantProfile from "../containers/Company-portal/Applicants/ViewApplicantProfile";
  import TimeSheet from "../containers/Admin-portal/TimeSheet";
  import MonthlyReport from "../containers/Admin-portal/TimeSheet/MonthlyReport";
  import DailyReport from "../containers/Admin-portal/TimeSheet/DailyReport";
  import ApplicantReport from "../containers/Admin-portal/TimeSheet/ApplicantReport";
  import ApplicantRequests from "../containers/Admin-portal/Applicants/ViewApplicant/ApplicantRequests";
  import PastEvents from "../containers/Admin-portal/Applicants/ViewApplicant/PastEvents";
  import EvaluateApplicant from "../containers/Admin-portal/Events/EvaluateApplicant";
  import ViewEmployee from "../containers/Admin-portal/Employees/ViewEmployee";
  import EvaluationForm from "../containers/Admin-portal/Evaluations/EvaluationForm";
  import Notifications from "../containers/Notifications";
  import EditApplicantProfile from "../containers/Company-portal/Applicants/EditApplicantProfile";
  import ViewReport from "../containers/Admin-portal/Reports/ViewReport/ViewReport";
  import ViewRole from "../containers/Admin-portal/Role/ViewRole";
  import EditEvaluations from "../containers/Admin-portal/Evaluations/EditEvaluations";
  import RoleManagement from "../containers/Admin-portal/Role";

  import ClientSatisfactionScore from "../components/ClientSatisfactionScore/ClientSatisfactionScore";
  import ViewClient from "../containers/Admin-portal/ClientManagement/ViewClient";
  import AdminAddClient from "../containers/Admin-portal/ClientManagement/AddClient";
  import AdminEditClient from "../containers/Admin-portal/ClientManagement/EditClient";
  import AdminViewEmployee from "../containers/Admin-portal/TeamManagement/ViewEmployee";
  import AdminAddEmployee from "../containers/Admin-portal/TeamManagement/AddEmployee";
  import AdminViewRole from "../containers/Admin-portal/TeamManagement/ViewRole";
  import AdminCreateRole from "../containers/Admin-portal/TeamManagement/CreateRole";
  import NoPermission from "../containers/Auth/NoPermission";
  import EditEmployee from "../containers/Admin-portal/Employees/EditEmployees";
  import AdminPortalDashboard from "../containers/Admin-portal/Dashboard";
  import AdminActivityLog from "../containers/Admin-portal/ActivityLog";

  import CompanyPortalDashboard from "../containers/Company-portal/Dashboard";
  import CompanyPortalActivityLog from "../containers/Company-portal/ActivityLog";
  import CompanyPortalEvents from "../containers/Company-portal/Events";
  import CompanyPortalClients from "../containers/Company-portal/Clients";
  import CompanyPortalAddClient from "../containers/Company-portal/Clients/AddClient";
  import CompanyPortalViewClient from "../containers/Company-portal/Clients/ViewClient";
  import CompanyPortalEditClient from "../containers/Company-portal/Clients/EditClient";
  import CompanyPortalApplicants from "../containers/Company-portal/Applicants";
  import CompanyPortalProfile from "../containers/Company-portal/Settings/Profile";
  import CompanyPortalTeamsPermissions from "../containers/Company-portal/TeamsPermissions";
  import CompanyPortalCreateRole from "../containers/Company-portal/TeamsPermissions/CreateRole";
  import CompanyPortalViewRole from "../containers/Company-portal/TeamsPermissions/ViewRole";
  import CompanyPortalAddEmployee from "../containers/Company-portal/TeamsPermissions/AddEmployee";
  import CompanyPortalViewEmployee from "../containers/Company-portal/TeamsPermissions/ViewEmployee";
  import CompanyPortalSecurity from "../containers/Company-portal/Settings/Security";
  import CompanyPortalLoyalApplicants from "../containers/Company-portal/LoyalApplicants";
  import CompanyPortalReports from "../containers/Company-portal/Reports";
  import CompanyViewReport from "../containers/Company-portal/Reports/ViewReport";
  import EditCompanyProfile from "../containers/Company-portal/Settings/Profile/EditCompanyProfile";
  import CompanyCreateEvent from "../containers/Company-portal/Events/CreateEvent";
  import CompanyEditEvent from "../containers/Company-portal/Events/EditEvent";
  import CompanyViewEvent from "../containers/Company-portal/Events/View";
  import CompanyEvaluateApplicant from "../containers/Company-portal/Events/EvaluateApplicant";
  import ApplicantEvaluationResult from "../components/Events/Event/Evaluations/ApplicantEvaluationResult";
  import ClientPortalDashboard from "../containers/Client-portal/Dashboard";
  import ClientPortalEvents from "../containers/Client-portal/Events";
  import ClientPortalViewEvent from "../containers/Client-portal/Events/View";
  import ClientPortalReports from "../containers/Client-portal/Reports";
  // import ClientPortalFinance from "../containers/Client-portal/Finance";
  import ClientPortalSecurity from "../containers/Client-portal/Settings/Security";
  import ClientPortalSurvey from "../containers/Client-portal/Survey";
  import ClientCompanySelection from "../containers/Auth/ClientCompanySelection";
  import UIKit from "../containers/UIKit";
  import { adminPermissionModules, companyPermissionModules } from "../utils/Constants";

  /** Module access (can_view) required per admin-portal area; visitors/
   * supervisors without it are redirected to their first viewable route
   * (see PrivateRoute). Super admin always bypasses. */
  const ADMIN_ROUTE_MODULES = {
    employees: [adminPermissionModules.employees],
    applicants: [adminPermissionModules.applicants],
    roleManagement: [adminPermissionModules.rolesManagement],
    events: [adminPermissionModules.events],
    promotionRequests: [adminPermissionModules.promotions],
    timesheet: [adminPermissionModules.timesheet],
    evaluations: [adminPermissionModules.evaluations],
    companiesList: [adminPermissionModules.manageClients],
  };

  /** Module access (can_view) required per company-portal area; employees
   * without it are redirected to Events (see PrivateRoute). */
  const COMPANY_ROUTE_MODULES = {
    events: [companyPermissionModules.events],
    clients: [companyPermissionModules.manageClients],
    applicants: [companyPermissionModules.applicants],
    teamsPermissions: [
      companyPermissionModules.employees,
      companyPermissionModules.rolesManagement,
    ],
    employees: [companyPermissionModules.employees],
    roles: [companyPermissionModules.rolesManagement],
    evaluations: [companyPermissionModules.evaluations],
    reports: [companyPermissionModules.reports],
  };

  function CompanyPortalLoginRoute(props) {
    return <CompanyLoginFlow {...props} type={AUTH_CONTEXT_TYPE.COMPANY} />;
  }
  CompanyPortalLoginRoute.displayName = "CompanyPortalLoginRoute";

  function AdminEventReportsRedirect({ match }) {
    const eventId = match?.params?.id;
    return (
      <Redirect
        to={`${ROUTE_PATHS.viewEvent.replace(":id", eventId)}?tab=reports`}
      />
    );
  }
  AdminEventReportsRedirect.displayName = "AdminEventReportsRedirect";
  AdminEventReportsRedirect.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({ id: PropTypes.string }),
    }),
  };

  function AdminCompanyTeamEmployeeViewRoute(props) {
    return <AdminViewEmployee {...props} />;
  }
  AdminCompanyTeamEmployeeViewRoute.displayName = "AdminCompanyTeamEmployeeViewRoute";

  function AdminCompanyTeamEmployeeCreateRoute(props) {
    return <AdminAddEmployee {...props} />;
  }
  AdminCompanyTeamEmployeeCreateRoute.displayName = "AdminCompanyTeamEmployeeCreateRoute";

  function AdminCompanyTeamRoleViewRoute(props) {
    return <AdminViewRole {...props} />;
  }
  AdminCompanyTeamRoleViewRoute.displayName = "AdminCompanyTeamRoleViewRoute";

  function AdminCompanyTeamRoleCreateRoute(props) {
    return <AdminCreateRole {...props} />;
  }
  AdminCompanyTeamRoleCreateRoute.displayName = "AdminCompanyTeamRoleCreateRoute";

  function AdminCompanyClientViewRoute(props) {
    return <ViewClient {...props} />;
  }
  AdminCompanyClientViewRoute.displayName = "AdminCompanyClientViewRoute";

  function AdminCompanyClientCreateRoute(props) {
    return <AdminAddClient {...props} />;
  }
  AdminCompanyClientCreateRoute.displayName = "AdminCompanyClientCreateRoute";

  function AdminCompanyClientEditRoute(props) {
    return <AdminEditClient {...props} />;
  }
  AdminCompanyClientEditRoute.displayName = "AdminCompanyClientEditRoute";

  function AdminViewApplicantProfileRoute(props) {
    return <ViewApplicantProfile {...props} portalVariant="admin-portal" />;
  }
  AdminViewApplicantProfileRoute.displayName = "AdminViewApplicantProfileRoute";

  function CompanyViewApplicantProfileRoute(props) {
    return <ViewApplicantProfile {...props} portalVariant="company-portal" />;
  }
  CompanyViewApplicantProfileRoute.displayName = "CompanyViewApplicantProfileRoute";

  function AdminEditApplicantProfileRoute(props) {
    return <EditApplicantProfile {...props} portalVariant="admin-portal" />;
  }
  AdminEditApplicantProfileRoute.displayName = "AdminEditApplicantProfileRoute";

  function CompanyEditApplicantProfileRoute(props) {
    return <EditApplicantProfile {...props} portalVariant="company-portal" />;
  }
  CompanyEditApplicantProfileRoute.displayName = "CompanyEditApplicantProfileRoute";

  function LegacyCompaniesListRedirect({ location }) {
    return (
      <Redirect
        to={{
          pathname: location.pathname.replace("/companies/list", "/companies"),
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  }
  LegacyCompaniesListRedirect.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string,
      hash: PropTypes.string,
    }).isRequired,
  };
  LegacyCompaniesListRedirect.displayName = "LegacyCompaniesListRedirect";

  function LegacyApplicantProfileRedirectRoute({ match }) {
    return (
      <Redirect
        to={ROUTE_PATHS.viewApplicant.replace(":id", match.params.id)}
      />
    );
  }
  LegacyApplicantProfileRedirectRoute.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  LegacyApplicantProfileRedirectRoute.displayName = "LegacyApplicantProfileRedirectRoute";

  const Routes = (
    <Router history={history}>
      <Switch>
        {/* Internal UI foundation reference — hidden in production builds */}
        {process.env.NODE_ENV !== "production" && (
          <Route component={UIKit} path="/ui-kit" exact />
        )}
        {/* Client portal */}
        <Redirect
          exact
          from={ROUTE_PATHS.clientRoot}
          to={ROUTE_PATHS.clientLogin}
        />
        <PrivateRoute
          component={ClientPortalDashboard}
          path={ROUTE_PATHS.clientPortalDashboard}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientPortalEvents}
          path={ROUTE_PATHS.clientPortalEvents}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientPortalViewEvent}
          path={ROUTE_PATHS.clientPortalViewEvent}
          exact
          permission={false}
        />
        {/* <PrivateRoute
          component={ClientPortalFinance}
          path={ROUTE_PATHS.clientPortalFinance}
          exact
          permission={false}
        /> */}
        <PrivateRoute
          component={ClientPortalSecurity}
          path={ROUTE_PATHS.clientSettingsSecurity}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientPortalSecurity}
          path={ROUTE_PATHS.clientChangePassword}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientPortalReports}
          path={ROUTE_PATHS.clientPortalReports}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientPortalSurvey}
          path={ROUTE_PATHS.clientSurveyPortal}
          exact
          permission={false}
        />
        {/*CLIENT SURVEY*/}
        <PrivateRoute
          component={() => <EventsListView destination="clientSurvey" />}
          path={[ROUTE_PATHS.clientSurvey]}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientSatisfactionScore}
          path={[ROUTE_PATHS.clientSurvey]}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ClientSatisfactionScore}
          path={[ROUTE_PATHS.clientSurveyByID]}
          exact
          permission={false}
        />
        {/* Company portal — `/company/*` app (session must be company; see PrivateRoute) */}
        <Redirect
          exact
          from={`${COMPANY_PREFIX}/settings`}
          to={ROUTE_PATHS.companySettingsProfile}
        />
        <PrivateRoute
          component={CompanyPortalDashboard}
          path={ROUTE_PATHS.companyDashboard}
          exact
          permission={false}
          companyOwnerOnly
        />
        <PrivateRoute
          component={CompanyPortalActivityLog}
          path={ROUTE_PATHS.companyActivityLog}
          exact
          permission={false}
          companyOwnerOnly
        />
        <PrivateRoute
          component={NoPermission}
          path={ROUTE_PATHS.companyNoPermission}
          exact
          permission={false}
        />
        <PrivateRoute
          component={CompanyPortalEvents}
          path={ROUTE_PATHS.companyEvents}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.events}
        />
        <PrivateRoute
          component={CompanyCreateEvent}
          path={ROUTE_PATHS.companyCreateEvent}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.events}
          companyModuleFlag="can_add"
        />
        <PrivateRoute
          component={CompanyEditEvent}
          path={ROUTE_PATHS.companyEditEvent}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.events}
          companyModuleFlag="can_edit"
        />
        <PrivateRoute
          component={CompanyEvaluateApplicant}
          path={ROUTE_PATHS.companyEvaluateApplicant}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.evaluations}
          companyModuleFlag="can_edit"
        />
        <PrivateRoute
          component={ApplicantEvaluationResult}
          path={ROUTE_PATHS.ApplicantEvaluationResult}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.events}
        />
        <PrivateRoute
          component={CompanyViewEvent}
          path={ROUTE_PATHS.companyViewEvent}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.events}
        />
        <PrivateRoute
          component={CompanyPortalClients}
          path={ROUTE_PATHS.companyClients}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.clients}
        />
        <PrivateRoute
          component={CompanyPortalAddClient}
          path={ROUTE_PATHS.companyAddClient}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.clients}
          companyModuleFlag="can_add"
        />
        <PrivateRoute
          component={CompanyPortalViewClient}
          path={ROUTE_PATHS.companyViewClient}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.clients}
        />
        <PrivateRoute
          component={CompanyPortalEditClient}
          path={ROUTE_PATHS.companyEditClient}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.clients}
          companyModuleFlag="can_edit"
        />
        <PrivateRoute
          component={CompanyPortalApplicants}
          path={ROUTE_PATHS.companyApplicants}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.applicants}
        />
        <PrivateRoute
          component={CompanyViewApplicantProfileRoute}
          path={ROUTE_PATHS.companyViewApplicantProfile}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.applicants}
        />
        <PrivateRoute
          component={CompanyPortalLoyalApplicants}
          path={ROUTE_PATHS.companyLoyalApplicants}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.applicants}
        />
        <PrivateRoute
          component={CompanyPortalReports}
          path={ROUTE_PATHS.companyReports}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.reports}
        />
        <PrivateRoute
          component={CompanyViewReport}
          path={ROUTE_PATHS.companyViewReport}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.reports}
        />
        <PrivateRoute
          component={CompanyEditApplicantProfileRoute}
          path={ROUTE_PATHS.companyEditApplicantProfile}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.applicants}
          companyModuleFlag="can_edit"
        />
        <PrivateRoute
          component={CompanyPortalProfile}
          path={ROUTE_PATHS.companySettingsProfile}
          exact
          permission={false}
        />
        <PrivateRoute
          component={CompanyPortalCreateRole}
          path={ROUTE_PATHS.companyTeamRoleCreate}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.roles}
          companyModuleFlag="can_add"
        />
        <PrivateRoute
          component={CompanyPortalAddEmployee}
          path={ROUTE_PATHS.companyTeamEmployeeCreate}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.employees}
          companyModuleFlag="can_add"
        />
        <PrivateRoute
          component={CompanyPortalViewEmployee}
          path={ROUTE_PATHS.companyTeamEmployeeView}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.employees}
        />
        <PrivateRoute
          component={CompanyPortalViewRole}
          path={ROUTE_PATHS.companyTeamRoleView}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.roles}
        />
        <PrivateRoute
          component={CompanyPortalTeamsPermissions}
          path={ROUTE_PATHS.companyTeamsPermissions}
          exact
          permission={false}
          companyModules={COMPANY_ROUTE_MODULES.teamsPermissions}
        />
        <PrivateRoute
          component={EditCompanyProfile}
          path={ROUTE_PATHS.companySettingsProfileEdit}
          exact
          permission={false}
        />
        <PrivateRoute
          component={CompanyPortalSecurity}
          path={ROUTE_PATHS.companySettingsSecurity}
          exact
          permission={false}
        />
        <PrivateRoute
          component={Notifications}
          path={ROUTE_PATHS.companyNotifications}
          exact
          permission={false}
        />
        <PrivateRoute
          component={Notifications}
          path={ROUTE_PATHS.clientNotifications}
          exact
          permission={false}
        />

        {/* Super Admin dashboard */}
        <PrivateRoute
          component={AdminPortalDashboard}
          path={ROUTE_PATHS.adminDashboard}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminActivityLog}
          path={ROUTE_PATHS.adminActivityLog}
          exact
          permission={false}
        />

        {/* Events */}
        <PrivateRoute
          component={EventsListView}
          path={[ROUTE_PATHS.events, ROUTE_PATHS.requestsEvents]}
          exact
          permission={false}
        />
        <PrivateRoute
          component={CreateEventV2}
          path={ROUTE_PATHS.createEvent}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.events}
          adminModuleFlag="can_add"
        />
        <PrivateRoute
          component={CreateEventV2}
          path={ROUTE_PATHS.editEvent}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.events}
          adminModuleFlag="can_edit"
        />
        <PrivateRoute
          component={ViewEventV2}
          path={ROUTE_PATHS.viewEvent}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.events}
        />
        <PrivateRoute
          component={ApplicantEvaluationResult}
          path={ROUTE_PATHS.adminApplicantEvaluationResult}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.events}
        />
        <PrivateRoute
          component={EvaluateApplicant}
          path={ROUTE_PATHS.adminEvaluateApplicant}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.events}
        />
        <PrivateRoute
          component={EvaluateApplicant}
          path={ROUTE_PATHS.adminEvaluateApplicant}
          exact
          permission={false}
        />
        <PrivateRoute
          component={InviteApplicants}
          path={ROUTE_PATHS.inviteApplicants}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.events}
        />
        {/*Reports — list lives in event view tab; keep detail + legacy redirect */}
        <PrivateRoute
          component={AdminEventReportsRedirect}
          path={ROUTE_PATHS.viewReport}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ViewReport}
          path={ROUTE_PATHS.viewReportDetail}
          exact
          permission={false}
        />

        {/* Requests */}
        <PrivateRoute
          component={Requests}
          path={ROUTE_PATHS.viewRequests}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminViewApplicantProfileRoute}
          path={ROUTE_PATHS.viewRequestsApplicant}
          exact
          permission={false}
        />
        <PrivateRoute
          component={PromotionRequests}
          path={ROUTE_PATHS.promotionRequests}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.promotionRequests}
        />
        <PrivateRoute
          component={DemoRequests}
          path={ROUTE_PATHS.demoRequests}
          exact
          permission={false}
        />
        <PrivateRoute
          component={CompanyViewDetailsPage}
          path={ROUTE_PATHS.registrationRequestCompanyView}
          exact
          permission={false}
        />
        <PrivateRoute
          component={RegistrationReqPage}
          path={ROUTE_PATHS.registrationRequests}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ProfileEditRequestsPage}
          path={ROUTE_PATHS.profileEditRequests}
          exact
          permission={false}
        />
        <PrivateRoute
          component={PublishingRequests}
          path={ROUTE_PATHS.publishingRequests}
          exact
          permission={false}
        />
        <Route
          path={`${ADMIN_PREFIX}/companies/list`}
          render={(props) => <LegacyCompaniesListRedirect {...props} />}
        />
        <PrivateRoute
          component={CompaniesList}
          path={ROUTE_PATHS.companiesList}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.companiesList}
        />
        <PrivateRoute
          component={CompanyEditPage}
          path={ROUTE_PATHS.companiesListCompanyEdit}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.companiesList}
          adminModuleFlag="can_edit"
        />
        <PrivateRoute
          component={CompanyDetailsPage}
          path={ROUTE_PATHS.companiesListCompanyDetails}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.companiesList}
        />
        <PrivateRoute
          component={CompanyDetailsClientsTabRedirect}
          path={ROUTE_PATHS.companiesListCompanyClients}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.companiesList}
        />
        {/* Company team — nested under companies list (create routes before :id) */}
        <PrivateRoute
          component={AdminCompanyTeamEmployeeCreateRoute}
          path={ROUTE_PATHS.adminCompanyTeamEmployeeCreate}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminCompanyTeamEmployeeViewRoute}
          path={ROUTE_PATHS.adminCompanyTeamEmployeeView}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminCompanyTeamRoleCreateRoute}
          path={ROUTE_PATHS.adminCompanyTeamRoleCreate}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminCompanyTeamRoleViewRoute}
          path={ROUTE_PATHS.adminCompanyTeamRoleView}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ReviewProfileUpdateRequestPage}
          path={ROUTE_PATHS.reviewProfileUpdateRequest}
          exact
          permission={false}
        />

        {/* Employees */}
        <PrivateRoute
          component={Employees}
          path={ROUTE_PATHS.employees}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.employees}
        />
        {/* `editProfile`/`profile` are the logged-in user's own profile — not
         * gated by the Employees module (every session must reach it). */}
        <PrivateRoute
          component={AddProjectManager}
          path={[ROUTE_PATHS.addProjectManager]}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.employees}
          adminModuleFlag="can_add"
        />
        <PrivateRoute
          component={AddProjectManager}
          path={[ROUTE_PATHS.editProfile]}
          exact
          permission={false}
        />
        <PrivateRoute
          component={ViewEmployee}
          path={[ROUTE_PATHS.viewEmployee]}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.employees}
        />
        <PrivateRoute
          component={ViewEmployee}
          path={[ROUTE_PATHS.profile]}
          exact
          permission={false}
        />
        <PrivateRoute
          component={EditEmployee}
          path={[ROUTE_PATHS.editEmployees]}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.employees}
        />

        {/* Applicants */}
        <PrivateRoute
          component={Applicants}
          path={ROUTE_PATHS.applicants}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.applicants}
        />
        <PrivateRoute
          component={AdminViewApplicantProfileRoute}
          path={ROUTE_PATHS.viewApplicant}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.applicants}
        />
        <PrivateRoute
          component={LegacyApplicantProfileRedirectRoute}
          path={ROUTE_PATHS.viewApplicantLegacy}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminEditApplicantProfileRoute}
          path={ROUTE_PATHS.editApplicantProfile}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.applicants}
          adminModuleFlag="can_edit"
        />
        <PrivateRoute
          component={ApplicantRequests}
          path={ROUTE_PATHS.viewApplicantRequests}
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.applicants}
        />
        <PrivateRoute
          component={PastEvents}
          path={ROUTE_PATHS.viewApplicantEvents}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.applicants}
        />

        <PrivateRoute
          component={EvaluationForm}
          path={ROUTE_PATHS.viewApplicantEvaluationView}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.evaluations}
        />
        <PrivateRoute
          component={EditEvaluations}
          path={ROUTE_PATHS.editEvaluations}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.evaluations}
          adminModuleFlag="can_edit"
        />
        <PrivateRoute
          component={EvaluationForm}
          path={ROUTE_PATHS.viewApplicantEvaluationEdit}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.evaluations}
          adminModuleFlag="can_edit"
        />

        {/* Timesheet */}
        <PrivateRoute
          component={TimeSheet}
          path={ROUTE_PATHS.timesheet}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.timesheet}
        />
        <PrivateRoute
          component={MonthlyReport}
          path={ROUTE_PATHS.monthlyReport}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.timesheet}
        />
        <PrivateRoute
          component={DailyReport}
          path={ROUTE_PATHS.dailyReport}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.timesheet}
        />
        <PrivateRoute
          component={ApplicantReport}
          path={ROUTE_PATHS.applicantReport}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.timesheet}
        />
        {/*Role Management*/}
        <PrivateRoute
          component={RoleManagement}
          path={ROUTE_PATHS.roleManagement}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.roleManagement}
        />
        <PrivateRoute
          component={ViewRole}
          path={ROUTE_PATHS.viewRoleManagement}
          exact
          permission={false}
          adminModules={ADMIN_ROUTE_MODULES.roleManagement}
        />
        <PrivateRoute
          component={ChangePassword}
          path={ROUTE_PATHS.changePassword}
          exact
          permission={true}
        />

        <PrivateRoute
          component={ChangePassword}
          path={ROUTE_PATHS.companyChangePassword}
          exact
          permission={true}
        />

        <PrivateRoute
         component={Notifications} 
          path={ROUTE_PATHS.notifications}
          exact
          permission={false}
        />

        {/* Client Management — nested under company */}
        <PrivateRoute
          component={AdminCompanyClientViewRoute}
          path={ROUTE_PATHS.adminCompanyViewClient}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminCompanyClientCreateRoute}
          path={ROUTE_PATHS.adminCompanyAddClient}
          exact
          permission={false}
        />
        <PrivateRoute
          component={AdminCompanyClientEditRoute}
          path={ROUTE_PATHS.adminCompanyEditClient}
          exact
          permission={false}
        />

        <PrivateRoute
          component={() => <EventsListView destination="adminClientEventSurvey" />}
          path={ROUTE_PATHS.adminclientSurvey}
          exact
          permission={false}
        />

        <PrivateRoute
          component={() => (
            <ClientSatisfactionScore adminclientClassifiction={true} />
          )}
          path={ROUTE_PATHS.adminClientEventSurvey}
          exact
          permission={false}
        />

        <PrivateRoute
          component={NoPermission}
          path={ROUTE_PATHS.noPermission}
          exact
          permission={false}
        />

        <PublicRoute
          component={ForgetPassword}
          path={ROUTE_PATHS.forgetPassword}
          exact
        />

        <PublicRoute
          component={ForgetPassword}
          path={ROUTE_PATHS.companyForgetPassword}
          exact
        />

        <PublicRoute
          component={ForgetPassword}
          path={ROUTE_PATHS.clientForgetPassword}
          exact
        />

        <PublicRoute
          component={ResetPasswordSuccess}
          path={ROUTE_PATHS.resetPasswordSuccess}
          exact
        />

        <PublicRoute
          component={ResetPasswordSuccess}
          path={ROUTE_PATHS.companyResetPasswordSuccess}
          exact
        />

        <PublicRoute
          component={ResetPasswordSuccess}
          path={ROUTE_PATHS.clientResetPasswordSuccess}
          exact
        />

        <PrivateRoute
          component={withAuthType(ResetPasswordInternally, AUTH_CONTEXT_TYPE.ADMIN)}
          path={ROUTE_PATHS.resetPassword}
          exact
          permission={false}
        />

        <PublicRoute
          component={ChangePassword}
          path={ROUTE_PATHS.companyChangePassword}
          exact
        />

        <PublicRoute
          component={withAuthType(ResetPasswordFlow, AUTH_CONTEXT_TYPE.COMPANY)}
          path={ROUTE_PATHS.companyResetPassword}
          exact
        />

        <PublicRoute
          component={withAuthType(ResetPasswordFlow, AUTH_CONTEXT_TYPE.CLIENT)}
          path={ROUTE_PATHS.clientResetPassword}
          exact
        />

        <PublicRoute
          component={ClientPortalSecurity}
          path={ROUTE_PATHS.clientChangePassword}
          exact
        />

        {/* Authentication — shared pages; `type` discriminates admin vs company portal */}
        <PublicRoute
          component={withAuthType(Login, AUTH_CONTEXT_TYPE.ADMIN)}
          path={ROUTE_PATHS.login}
          exact
        />
        <PublicRoute
          component={withAuthType(Login, AUTH_CONTEXT_TYPE.CLIENT)}
          path={ROUTE_PATHS.clientLogin}
          exact
        />
        <PublicRoute
          component={ClientCompanySelection}
          path={ROUTE_PATHS.clientSelectCompany}
          exact
        />
        <Redirect from="/signup" to={ROUTE_PATHS.companySignup} exact />
        <PublicRoute
          component={CompanyPortalLoginRoute}
          path={ROUTE_PATHS.companyLogin}
        />
        <PublicRoute
          component={withAuthType(RegistrationFlow, AUTH_CONTEXT_TYPE.COMPANY)}
          path={ROUTE_PATHS.companySignup}
        />
        <PublicRoute
          component={withAuthType(
            CompanyPendingApprovalPage,
            AUTH_CONTEXT_TYPE.COMPANY,
          )}
          path={ROUTE_PATHS.companyPendingApproval}
          exact
        />
        <Redirect
          from="/company/signup/pending"
          to={ROUTE_PATHS.companyPendingApproval}
          exact
        />
        <PublicRoute
          component={CompanyDeactivated}
          path={ROUTE_PATHS.companyDeactivated}
          exact
        />

        <Redirect
          exact
          from={ROUTE_PATHS.companyRoot}
          to={ROUTE_PATHS.companyLogin}
        />
        <Redirect
          exact
          from={ROUTE_PATHS.adminRoot}
          to={ROUTE_PATHS.login}
        />

        <Route
          exact
          path="/"
          render={() => <Redirect to={getDefaultAppEntryPath()} />}
        />
        <Route render={() => <Redirect to={getDefaultAppEntryPath()} />} />
      </Switch>
    </Router>
  );
  export default Routes;
